import { CourseService } from 'data/services/course';
import { CourseServiceInterface } from 'domain/services';
import { makeRemoteCourseCreate } from 'main/factories/usecases/Course/course-create-factory';
import { makeRemoteCourseDelete } from 'main/factories/usecases/Course/course-delete-factory';
import { makeRemoteCourseGetById } from 'main/factories/usecases/Course/course-get-by-id-factory';
import { makeRemoteCourseList } from 'main/factories/usecases/Course/course-list-factory';
import { makeRemoteCourseUpdate } from 'main/factories/usecases/Course/course-update-factory';
import { makeRemoteGetAllCoursesByPerson } from 'main/factories/usecases/Course/get-all-courses-by-person-factory';
import { makeGetAllCoursesUser } from 'main/factories/usecases/courses/remote-get-all-courses-user-factory';

export const makeCourseService = (): CourseServiceInterface => {
  return new CourseService({
    courseList: makeRemoteCourseList(),
    courseCreate: makeRemoteCourseCreate(),
    courseUpdate: makeRemoteCourseUpdate(),
    courseDelete: makeRemoteCourseDelete(),
    courseGetById: makeRemoteCourseGetById(),
    getAllCoursesByPerson: makeRemoteGetAllCoursesByPerson(),
    getAllCoursesByUser: makeGetAllCoursesUser(),
  });
};
